import React, { useState, useEffect } from 'react'
import DeclinedBankComponent from '../declined/declined-bank'
import routes from '../../../../../resources/routes.json';
import useLoan from '../../../hooks/useLoan'; 
import Loading from '../../../components/features/loading/loading';
import { setEventOnDataLayer } from '../../../utils/helper/datalayer-events-helper';

export default function index() {
  const  { findLoanAndRedirect, loan } = useLoan();
  const [loading, setLoading] = useState(true);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false)

  const onSuccess = () =>{
    setEventOnDataLayer('funil_bancoNaoAceito_atualizado');
    findLoanAndRedirect(routes.LOAN_APPLICATION_PENDING_ACCEPTABLE_BANK);
    setShowSuccessMessage(true);
    window.location.reload();
  };

  useEffect(() =>{
    findLoanAndRedirect(routes.LOAN_APPLICATION_PENDING_ACCEPTABLE_BANK)
  }, []);

  useEffect(() =>{
    if(loan?.id){
      setLoading(false)
    }
  },[loan?.id]);

  return (
    loading ? (
      <Loading />
    ) : (
      <>
        {showSuccessMessage &&(
          <h3 className="text-5 mt-2 mb-2 center col-lg-8 col-md-12 col-sm-12 text-success">
            A atualização da sua conta bancária foi realizada!
          </h3>
        )}

        <DeclinedBankComponent title="Informe seus dados bancários novamente." onSuccessUpdate={onSuccess} withAdd={false}/>
      </>
    )
  )
}
